module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('h3', [_vm._v("Sales Report")])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "Start Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.fromDate),
            callback: function($$v) {
              _vm.fromDate = $$v
            },
            expression: "fromDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu = false
      }
    },
    model: {
      value: (_vm.fromDate),
      callback: function($$v) {
        _vm.fromDate = $$v
      },
      expression: "fromDate"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": "",
      "md3": "",
      "px-1": "",
      "mt-2": ""
    }
  }, [_c('v-flex', {
    staticClass: "date__picker"
  }, [_c('v-menu', {
    attrs: {
      "close-on-content-click": false,
      "nudge-right": 40,
      "lazy": "",
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "min-width": "290px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function(ref) {
        var on = ref.on;

        return [_c('v-text-field', _vm._g({
          attrs: {
            "label": "End Date",
            "prepend-icon": "event",
            "readonly": "",
            "clearable": ""
          },
          model: {
            value: (_vm.toDate),
            callback: function($$v) {
              _vm.toDate = $$v
            },
            expression: "toDate"
          }
        }, on))]
      }
    }]),
    model: {
      value: (_vm.menu1),
      callback: function($$v) {
        _vm.menu1 = $$v
      },
      expression: "menu1"
    }
  }, [_vm._v(" "), _c('v-date-picker', {
    on: {
      "input": function($event) {
        _vm.menu1 = false
      }
    },
    model: {
      value: (_vm.toDate),
      callback: function($$v) {
        _vm.toDate = $$v
      },
      expression: "toDate"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-data-table', {
    attrs: {
      "items": _vm.items,
      "headers": _vm.analyticHeaders,
      "loading": _vm.loading,
      "item-key": "id",
      "hide-actions": "",
      "disable-initial-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.id))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.invoice_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.created_at))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_name') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.casket ? props.item.workcase.casket.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item && props.item.workcase && props.item.workcase.plan && props.item.workcase.plan.name ? props.item.workcase.plan.name : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_death_certificate_no') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_location_of_wake') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'agreement_form_data', 'ash_collection_location') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'agreement_form_data', 'ash_collection_vendor') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'client_form_data', 'name') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'client_form_data', 'mailing_address') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'client_form_data', 'contact_number') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'client_form_data', 'email') : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.calculatePriceWithGST(props.item.workcase.totalPrice)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.payment_info ? _vm.getPaymentMode(props.item.workcase.payment_info) : '-'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.manager_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getCremationTime(props.item)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.workcase.answers ? _vm.getAnswerItem(props.item.workcase.answers, 'main_form', 'deceased_burial_location') : '-'))])])]
      }
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "align-right"
  }, [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.exportToCSV(_vm.items)
      }
    }
  }, [_vm._v("Export to CSV")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-00b6501c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/resources/SalesReport.vue
// module id = 944
// module chunks = 1